import { CButton, CIcon, CText } from '@carrefour/design-system-components-react';
import styled from 'styled-components';
import { COLORS } from '../../utils/colors';

/* ===== Styled Components ===== */

const BannerContainer = styled.div<{ bannerColor?: string, isClickable?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${(props) => props.bannerColor || '#e8f1f8'};
  padding: 15px 0px 15px 8px;
  margin: 15px 15px 5px 15px;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  cursor: ${(props) => (props.isClickable ? 'pointer' : 'default')};
`;

const IconCustom = styled(CIcon)`
  font-size: 1.5rem;
  color: #173EB4;
`;

const LeftSection = styled.div<{ flexDirection?: string, gap?: string, alignItems?: string }>`
  display: flex;
  flex-direction: ${props => props.flexDirection || 'row'};
  gap: ${props => props.gap || '0px'};
  ${props => props.alignItems && `align-items: ${props.alignItems};`}
`;

const CTextCustom = styled(CText)<{ fontSize?: string, fontWeight?: string }>`
  font-weight: ${props => props.fontWeight || '400'};
  text-align: left;
  margin-bottom: 2px;
`;

const StyledLink = styled.a`
  cursor: pointer;
  text-decoration: none;
  color: #0970E6;
  white-space: nowrap;
  font-weight: bold;
  margin-left: auto;
  margin-right: 15px;
  margin-top: 10px;
`;

/* ===== Component ===== */

const Banner: React.FC<{ data: { id: string; title: string; text: string; link?: string }; icon: string; type: string; isCloseable: boolean; handleDismiss?: (id: string) => void }> = ({ data, icon, type, isCloseable, handleDismiss }) => {
  return (
        <BannerContainer 
          key={data.id || data.title} 
          data-testid="communication-banner"
          bannerColor={type === "ALERT" ? COLORS.bg_red : "#E8F8FF"}
          isClickable={false} 
        >
          <LeftSection gap="8px" alignItems="center" style={{ flex: 1 }}>
            <IconCustom name={icon} />
            <LeftSection flexDirection="column" style={{ flex: 1 }}>
              <CTextCustom size="m" fontWeight="700">{data.title}</CTextCustom>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                <CTextCustom size="s" style={{ marginBottom: 0 }}>{data.text}</CTextCustom>
              </div>
            </LeftSection>
            {data.link && (
              <StyledLink
                href={data.link}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => data.link && window.open(data.link, "_blank")}
              >
                Lien
              </StyledLink>
            )}
          </LeftSection>

          {isCloseable && (
            <CButton variation='tertiary' tone='monochrome'
              onClick={(e) => {
                e.stopPropagation(); // prevents triggering banner click
                handleDismiss?.(data.id);
              }}
            >
              ✕
            </CButton>
          )}
        </BannerContainer>      
  );
};

export default Banner;